import React from "react";
import CTAButton from "../../Buttons/CTAButton/CTAButton";
import GlobeHemisphereWest from "../../Icons/GlobeHemisphereWest";
import BookOpenText from "../../Icons/BookOpenText";
import MicroscopeLine from "../../Icons/MicroscopeLine";

const AcademicSectionMobile = () => {
  return (
    <div>
      <div className="self-stretch px-2 pt-24 pb-8 bg-Color-Primary inline-flex flex-col justify-center items-start gap-12">
        <div className="self-stretch px-2 pt-16 flex flex-col justify-start items-start gap-8">
          <div className="self-stretch px-2 border-l border-Color-Black-20/20 flex flex-col justify-end items-start gap-8">
            <div className="self-stretch justify-start">
              <span class="text-Color-White text-3xl font-medium font-['Montserrat']">
                Academic
              </span>
              <span class="text-Color-White text-2xl font-medium font-['Montserrat']">
                {" "}
              </span>
              <span class="text-Color-White text-3xl font-bold font-['Montserrat']">
                Excellence
              </span>
            </div>
            <div className="self-stretch justify-start text-Color-White text-xs font-normal font-['Montserrat'] tracking-tight">
              For 25 remarkable years, we have been committed to providing a
              world-class engineering education, fostering a rigorous learning
              environment, and empowering our students with the knowledge and
              skills necessary to excel in a rapidly evolving global landscape.
            </div>
          </div>
          <CTAButton text="READ MORE" url="https://www.eng.ruh.ac.lk/academic/" target="_blank" variant="whiteRainbow" newTab={true} isWhiteButton = {true}/>
        </div>
        <div className="self-stretch p-4 bg-Color-White bg-opacity-5 rounded-tl-2xl rounded-br-2xl flex flex-col justify-start items-start gap-12 overflow-hidden">
          <div className="self-stretch flex flex-col justify-start items-start gap-4">
            <div className="w-6 h-6 relative overflow-hidden">
              <GlobeHemisphereWest className="w-5 h-5 left-[2.25px] top-[2.25px] absolute " />
            </div>
            <div className="self-stretch justify-start text-Color-White text-lg font-semibold font-['Montserrat']">
              Globally Recognized Programs:
            </div>
            <div className="self-stretch inline-flex justify-center items-center gap-2">
              <div className="flex-1 justify-start text-Color-White text-xs font-normal font-['Montserrat'] tracking-tight">
                Accredited by IESL and aligned with the Washington Accord, our
                degrees are respected worldwide, offering global career
                opportunities.
              </div>
            </div>
          </div>
          <div className="self-stretch flex flex-col justify-start items-start gap-4">
            <div className="w-6 h-6 relative overflow-hidden">
              <BookOpenText className="w-5 h-5 left-[1.50px] top-[4.50px] absolute" />
            </div>
            <div className="self-stretch justify-start text-Color-White text-lg font-semibold font-['Montserrat']">
              Expert-Led, Industry-Relevant Education:
            </div>
            <div className="self-stretch inline-flex justify-center items-center gap-2">
              <div className="flex-1 justify-start text-Color-White text-xs font-normal font-['Montserrat'] tracking-tight">
                Learn from experienced professionals who combine academic
                excellence with real-world engineering insight.
              </div>
            </div>
          </div>
          <div className="self-stretch flex flex-col justify-start items-start gap-4">
            <div className="w-6 h-6 relative overflow-hidden">
              <MicroscopeLine className="w-5 h-5 left-[3px] top-[1.27px] absolute" />
            </div>
            <div className="self-stretch justify-start text-Color-White text-lg font-semibold font-['Montserrat']">
              Hands-On Learning & Innovation:
            </div>
            <div className="self-stretch inline-flex justify-center items-center gap-2">
              <div className="flex-1 justify-start text-Color-White text-xs font-normal font-['Montserrat'] tracking-tight">
                Access advanced labs and engage in research-driven, practical
                projects that build critical problem-solving skills.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcademicSectionMobile;
